import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { VerifyOTP } from "../../../../hooks/User";

const StepOTP = ({ formData, prevStep, resendOTP, handleVerify }) => {
  const [otp, setOtp] = useState("");
  const [isResending, setIsResending] = useState(false);

  const handleResendOTP = async () => {
    setIsResending(true);
    try {
      // Simulate OTP resend - Replace with real API call to resend OTP
      await resendOTP();
      alert("OTP has been resent successfully!");
    } catch (error) {
      console.error("Error while resending OTP:", error);
      alert("Failed to resend OTP. Please try again later.");
    } finally {
      setIsResending(false);
    }
  };

  const handleSubmit = async () => {
    // Simulate OTP verification
    if (otp) {
      const body = {
        email: formData.email,
        otp:otp
      }
      
      const response = await VerifyOTP(body)
      alert("OTP Verified! Data submitted to backend.");
      console.log("Final Form Data:", response);
      handleVerify();

    } else {
      alert("Invalid OTP! Please try again.");
    }
  };

  return (
    <div className="container">
      <Form  className="box mt-4">
        <Form.Group>
          <p className="mt-3">Enter OTP</p>
          <Form.Control
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={6}
          />
        </Form.Group>

        <div className="d-flex justify-content-between mt-3">
          <Button variant="secondary" onClick={prevStep}>
            Back
          </Button>
          <Button onClick={handleSubmit}>Done</Button>
        </div>

        {/* Resend OTP button */}
        <div className="mt-3 text-center">
          <Button
            variant="link"
            onClick={handleResendOTP}
            disabled={isResending}
          >
            {isResending ? "Resending OTP..." : "Resend OTP"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default StepOTP;
